import React, { forwardRef } from 'react';

const PrintComponent = forwardRef(({ order, isEditing, editedItems }, ref) => {
  return (
    <div ref={ref} className="print-container p-4 font-mono">
      <div className="text-center mb-4">
        <h1 className="text-2xl font-bold">Abbass Restaurant</h1>
      </div>

      <div className="border-b-2 border-black mb-2">
        <div className="flex justify-between mb-2">
          <span>Order #: {order.id}</span>
          <span>Date: {new Date(order.orderedAt).toLocaleDateString()}</span>
        </div>
        <div className="text-sm">
          Time: {new Date(order.orderedAt).toLocaleTimeString([], { 
            hour: '2-digit', 
            minute: '2-digit' 
          })}
        </div>
      </div>

      <div className="mb-4">
        {(!isEditing ? order.items : editedItems).map((item, index) => (
          <div key={index} className="flex justify-between py-1">
            <div>
              <span className="font-semibold">{item.quantity}x </span>
              {item.name}
            </div>
            <div>${(item.price * item.quantity).toFixed(2)}</div>
          </div>
        ))}
      </div>

      <div className="border-t-2 border-black pt-2">
        <div className="flex justify-between font-bold">
          <span>Total:</span>
          <span>${(!isEditing ? order.total : 
            editedItems.reduce((sum, item) => sum + (item.price * item.quantity), 0)
            .toFixed(2))}
          </span>
        </div>
      </div>

      <div className="text-center mt-6 text-sm">
        Thank you for dining with us!
        <br />
        VAT Included
      </div>
    </div>
  );
});

export default PrintComponent;
